"use strict";
/// <reference path="../../../typings/libraries.d.ts"/>
(function () {
    class ArticlesComponent {
        constructor(element) {
            this.articles = null;
            this.element = element;
            this.element.classList.add('articles-component');
        }
        refreshUI() {
            const loadingContentElement = this.element.querySelector('.loading-content');
            const noContentMessageElement = this.element.querySelector('.no-content-message');
            const articlesElement = this.element.querySelector('.articles');
            const buttonElement = this.element.querySelector('.articles-component__button');
            const buttonTitle = buttonElement.getAttribute('title') || '';
            if (this.articles === null) {
                Alkami.Dom.showElement(loadingContentElement);
                Alkami.Dom.hideElement(noContentMessageElement);
                Alkami.Dom.hideElement(articlesElement);
                return;
            }
            else if (this.articles.length === 0) {
                Alkami.Dom.hideElement(loadingContentElement);
                Alkami.Dom.showElement(noContentMessageElement);
                Alkami.Dom.hideElement(articlesElement);
                return;
            }
            Alkami.Dom.hideElement(loadingContentElement);
            Alkami.Dom.hideElement(noContentMessageElement);
            Alkami.Dom.showElement(articlesElement);
            articlesElement.innerHTML = this.articles.map((article) => {
                return `<div class="article">
               <h3 class="article__title"><a href="${article.url}">${article.displayName}</a></h3>
               <span class="article__date">${article.date}</span>
               <div class="article__content-body">${article.excerpt}</div>
               <a class="article__callout-link" href="${article.url}">${Alkami.Localization.SiteText['Global.Content.ReadMore']}</a>
            </div>`;
            }).join('');
            buttonElement.setAttribute('aria-label', `${buttonTitle} ${this.articles.length.toString(10)}`);
        }
    }
    function getEducationalArticles() {
        return new Promise((resolve) => {
            $.ajax({
                url: '/Api/Content/GetEducationalContentImpressions',
                data: { currentWidget: window.currentWidgetName },
                dataType: 'json',
                type: 'GET',
                success: function (data) {
                    const content = JSON.parse(data.ContentImpressions || "[]"); //YUCK: Why do we store the array object as a string? O.o
                    const articles = content.map((article) => {
                        return {
                            id: article.Id,
                            date: article.Date,
                            displayName: article.DisplayName,
                            excerpt: article.Excerpt,
                            url: `/Content/${article.Id}`
                        };
                    });
                    return resolve(articles);
                },
                error: function () {
                    // Hopefully we never get here.
                    return resolve([]);
                }
            });
        });
    }
    function getNewsArticles() {
        return new Promise((resolve) => {
            $.ajax({
                url: "/Api/Content/GetCurrentNews",
                data: { currentWidget: window.currentWidgetName },
                dataType: 'json',
                type: 'GET',
                success: function (data) {
                    const content = JSON.parse(data.Content || "[]"); //YUCK: Why do we store the array object as a string? O.o
                    const articles = content.map((article) => {
                        return {
                            id: article.Id,
                            date: article.Date,
                            displayName: article.DisplayName,
                            excerpt: article.Excerpt,
                            url: `/Content/${article.Id}`
                        };
                    });
                    return resolve(articles);
                },
                error: function () {
                    // Hopefully we never get here.
                    return resolve([]);
                }
            });
        });
    }
    function initArticlesComponent(element, getter) {
        const articlesComponent = new ArticlesComponent(element);
        let getterPromise = null;
        articlesComponent.refreshUI();
        element.addEventListener('expandend', () => {
            if (getterPromise) {
                return;
            }
            getterPromise = getter().then((articles) => {
                articlesComponent.articles = articles;
                articlesComponent.refreshUI();
                return articles;
            });
        });
        Alkami.Iris.PopoverComponent.refresh(element.querySelectorAll('[data-popover]'));
    }
    function initArticleAction(li, buttonOptions) {
        const oldButton = li.querySelector('button');
        const popover = li.querySelector('.iris-popover');
        const buttonAttributes = {
            'data-popover': '',
            'data-placement': 'bottom',
            'data-static-placement': '',
            'data-indicator': 'end',
            'title': oldButton.title,
            'aria-label': oldButton.title
        };
        const actionItem = new Alkami.WidgetHeader.ActionButtonItem(Object.assign({ buttonAttributes }, buttonOptions));
        actionItem.element.appendChild(popover);
        actionItem.element.classList.add('legacy-action-item');
        return actionItem;
    }
    function initHelpArticlesAction(li) {
        const oldButton = li.querySelector('a.help');
        const actionItem = new Alkami.WidgetHeader.ActionButtonItem({
            containerId: 'help_articles',
            iconName: 'help',
            text: oldButton.innerText,
            href: oldButton.href,
            buttonAttributes: {
                'title': oldButton.title,
                'aria-label': oldButton.title
            }
        });
        actionItem.buttonElement.classList.add('help-link');
        actionItem.element.classList.add('legacy-action-item');
        return actionItem;
    }
    async function init() {
        const relatedContentPromise = new Promise((resolve) => {
            document.body.addEventListener('irisinitstart', () => {
                const element = document.getElementById('related_content');
                if (!element) {
                    resolve(null);
                    return;
                }
                element.remove();
                // element.style.display = 'none';
                resolve(element);
            });
        });
        const widgetHeaderInitPromise = new Promise((resolve) => {
            document.body.addEventListener('widgetHeaderInitBefore', ((event) => resolve(event.detail.header)));
        });
        try {
            const relatedContent = await relatedContentPromise;
            if (!relatedContent) {
                return;
            }
            const header = await widgetHeaderInitPromise;
            const actionBar = header.actions;
            const educationLI = relatedContent.querySelector('#educational_articles');
            const newsLI = relatedContent.querySelector('#news_articles');
            const helpLI = relatedContent.querySelector('#help_articles');
            const helpLink = relatedContent.querySelector('#help_articles a.help');
            if (educationLI && window.currentWidgetName) {
                const actionItem = initArticleAction(educationLI, {
                    containerId: 'educational_articles',
                    iconName: 'education'
                });
                actionBar.append(actionItem);
                initArticlesComponent(actionItem.element, getEducationalArticles);
            }
            if (newsLI) {
                const actionItem = initArticleAction(newsLI, {
                    containerId: 'news_articles',
                    iconName: 'newspaper'
                });
                actionBar.append(actionItem);
                initArticlesComponent(actionItem.element, getNewsArticles);
            }
            if (helpLI && helpLink) {
                const actionItem = initHelpArticlesAction(helpLI);
                actionBar.append(actionItem);
                $('#help_articles .help-link').instructify();
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
    init();
})();


